<br><br>

<button class="btn btn-outline-secondary mr-3 mb-3" (click)="selectAll(1)">Seleziona tutto</button>
<button class="btn btn-outline-secondary mr-3 mb-3" (click)="selectAll(0)">Deseleziona tutto</button>

<div class="card">
  <h3 *ngIf="values[0]; else noValues" class="margin"><b translate>tables.device_counter.name.set</b></h3>
  <ng-template #noValues>
    <h3 class="margin"><b translate>tables.device_counter.name.notset</b></h3>
  </ng-template>
  <div class="card-group">
    <div class="col-12 col-md-6 col-lg-4 " style="overflow: hidden;" *ngFor="let serv of values">
      <div class="mt-3">
        <mat-checkbox class="grid-box" [checked]="serv.enabled"
        (change)="change($event, serv)">{{serv.name}}</mat-checkbox>
      </div>
    </div>

  </div>
</div>
